const ColorEnum = Object.freeze({
  2: "#FF7F55",
  3: "#7091F3",
  4: "#71CD90"
});

const SortOrder = Object.freeze({
  "ASCENDING": 1,
  "DESCENDING": 2
});

const Scopes = Object.freeze({
  "OFFICE_AND_SELECTED_OFFICES": 6,
  "PROFILE" : 5,
  "TEAM": 4,
  "OFFICE": 3,
  "SELECTED_OFFICES": 2,
  "ALL_OFFICES": 1
});

const Modes = Object.freeze({
  "CREATE": 1,
  "EDIT": 2,
  "COPY": 3
});

const Statuses = Object.freeze({
  "NOT_STARTED": 1,
  "SUCCESS": 2,
  "FAILURE": 3
});

const BackgroundColors = Object.freeze({
  "WHITE": 0,
  "WHITE_SMOKE": 1
});

const AccessLevels = Object.freeze({
  "USER": 1,
  "ADMIN": 2,
  "SYSTEM_ADMIN": 3
});

const ButtonTypes = Object.freeze({
  "SECONDARY": "SECONDARY",
  "PRIMARY":  "PRIMARY",
  "LINK": "LINK",
  "LINKSSO": "LINKSSO"
});

const UserSettingsSection = Object.freeze({
  "VIEW": "VIEW",
  "EDIT": "EDIT"
});

const RoleTypes = Object.freeze({
  "SYSTEM_ADMIN": 1,
  "LIMITED_ACCESS": 2
});

const PermissionCategories = Object.freeze({
  "ROLES": 1,
  "USERS": 2,
  "DEALS": 3,
  "QUICK_BOOKS": 4,
  "BANKING_RECONCILIATION" : 5
});

const UserInvitationStatus = Object.freeze({
  "INVITED": "INVITED",
  "PENDINGAPPROVAL": "PENDINGAPPROVAL",
  "APPROVED": "APPROVED"
});

const InvitationStatusText = Object.freeze({
  "REINVITE": "Re-Invite",
  "APPROVE": "Approve",
  "ACTIVE": "Active"
});

export {
  ColorEnum,
  SortOrder,
  Scopes,
  Modes,
  Statuses,
  BackgroundColors,
  AccessLevels,
  ButtonTypes,
  UserSettingsSection,
  RoleTypes,
  PermissionCategories,
  UserInvitationStatus,
  InvitationStatusText
};
